import type { StateCreator } from "zustand";

import type { ZGlobalNoteModal } from "../types";

export const globalNoteModalSlice: StateCreator<ZGlobalNoteModal> = (
  set,
  get,
) => ({
  openGlobalNoteModal: false,
  setOpenGlobalNoteModal: openGlobalNoteModal => {
    set({ openGlobalNoteModal });
    if (!openGlobalNoteModal) {
      set({ noteData: undefined, openGlobalNoteModalById: null });
    }
  },

  openGlobalNoteModalById: null,
  setOpenGlobalNoteModalById: openGlobalNoteModalById =>
    set({
      openGlobalNoteModalById,
      openGlobalNoteModal: true,
      mode: "maximized",
    }),

  openGlobalCreateNoteModal: false,
  setOpenGlobalCreateNoteModal: openGlobalCreateNoteModal =>
    set({ openGlobalCreateNoteModal }),

  mode: "default",
  setMode: mode => set({ mode }),

  noteData: undefined,
  updateNoteData: noteData => {
    const stateNote = get().noteData;
    if (!stateNote) return;

    set({
      noteData: {
        note_id: stateNote.note_id,
        title: noteData.title ?? stateNote.title,
        content: noteData.content ?? stateNote.content,
        tags: noteData.tags ?? stateNote.tags,
        modified_by: noteData.modified_by ?? stateNote.modified_by,
        updated_at: noteData.updated_at ?? stateNote.updated_at,
        created_at: stateNote.created_at,
        created_by: stateNote.created_by,
        entities: stateNote.entities,
      },
    });
  },

  triggerEditorFocus: true,
  setTriggerEditorFocus: triggerEditorFocus => {
    set({ triggerEditorFocus });
    if (triggerEditorFocus) {
      setTimeout(() => {
        set({ triggerEditorFocus: false });
      }, 10);
    }
  },
});
